class AlphabetTable extends HTMLElement {
    connectedCallback() {
      this.render();
      this.addEventListeners();
    }
  
    render() {
      const letters = alphabet_settings.letters;
      let html = '<ul>';
      
      if (alphabet_settings.include_numbers) {
        html += '<li><a href="#number" data-letter="#">#</a></li>';
      }
      
      letters.forEach(letter => {
        html += `<li><a href="#${letter}" data-letter="${letter}">${letter}</a></li>`;
      });
      
      if (alphabet_settings.all_button_text) {
        html += `<li><a href="#all" data-letter="all">${alphabet_settings.all_button_text}</a></li>`;
      }
      
      html += '</ul>';
      this.innerHTML = html;
    }
  
    addEventListeners() {
      this.querySelectorAll('a').forEach(anchor => {
        anchor.addEventListener('click', this.handleClick.bind(this));
      });
    }
  
    handleClick(e) {
      e.preventDefault();
      const letter = e.target.getAttribute('data-letter');
      this.filterCollections(letter);
      this.updateActiveClass(e.target);
    }
  
    filterCollections(letter) {
      const collectionsTable = document.querySelector('collections-table');
      collectionsTable.filterByLetter(letter);
    }
  
    updateActiveClass(clickedElement) {
      this.querySelectorAll('a').forEach(a => a.classList.remove('active'));
      clickedElement.classList.add('active');
    }
  }
  
  class CollectionsTable extends HTMLElement {
    connectedCallback() {
      this.render();
    }
  
    render() {
      const groupedCollections = this.groupCollectionsByLetter();
      const html = Object.entries(groupedCollections).map(([letter, collections]) => `
        <div id="${letter === '#' ? 'number' : letter}" class="letter-block">
          <h3>${this.getLetterTitle(letter)}</h3>
          <ul>
            ${collections.map(collection => `
              <li><a href="${collection.url}">${collection.title}</a></li>
            `).join('')}
          </ul>
        </div>
      `).join('');
      this.innerHTML = html;
    }
  
    groupCollectionsByLetter() {
      const grouped = {};
      collections.forEach(collection => {
        const firstLetter = collection.title.charAt(0).toUpperCase();
        const key = alphabet_settings.include_numbers && !isNaN(firstLetter) ? '#' : firstLetter;
        if (!grouped[key]) grouped[key] = [];
        grouped[key].push(collection);
      });
      return grouped;
    }
  
    getLetterTitle(letter) {
      if (letter === '#') {
        return letter_settings.find(s => s.number_title)?.number_title || 'Brands Starting with a Number';
      }
      const letterSetting = letter_settings.find(s => s.letter === letter);
      return letterSetting ? letterSetting.letter_block_title : `Brands Starting with ${letter}`;
    }
  
    filterByLetter(letter) {
      this.querySelectorAll('.letter-block').forEach(block => {
        if (letter === 'all' || block.id === letter || (letter === '#' && block.id === 'number')) {
          block.style.display = 'block';
        } else {
          block.style.display = 'none';
        }
      });
    }
  }
  
  customElements.define('alphabet-table', AlphabetTable);
  customElements.define('collections-table', CollectionsTable);
  
  // Initialize the page with all collections visible
  document.addEventListener('DOMContentLoaded', () => {
    const allButton = document.querySelector('alphabet-table a[data-letter="all"]');
    if (allButton) {
      allButton.classList.add('active');
    }
  });